/* POSH — خدمة شماغك جاهز: مكوّن الطلب (مقاس افتراضي + كروت + صفحة منبثقة + شريط ثابت)
   - لو الزائر برّه سوق الكويت، بنعرض تحويل للكويت ونرجّع اختياراته بعد التحويل. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var S = JSON.parse(root.querySelector('[data-styles]').textContent || '[]');
    var T = JSON.parse(root.querySelector('[data-svc-config]').textContent || '{}');
    var MAX = parseInt(root.dataset.max, 10) || 10;
    var STORE_KEY = 'poshSvcOrder';
    var el = function (s) { return root.querySelector(s); };

    /* حالة الخدمة بتوقيت الكويت */
    var OPEN = parseInt(root.dataset.open, 10), CLOSE = parseInt(root.dataset.close, 10);
    var statusEl = el('[data-status]'), statusText = el('[data-status-text]');
    function updateStatus() {
      var h = (new Date().getUTCHours() + 3) % 24;
      var on = h >= OPEN && h < CLOSE;
      statusEl.classList.toggle('is-closed', !on);
      statusText.textContent = on ? T.open : T.closed;
    }
    updateStatus();
    setInterval(updateStatus, 60000);

    var gsize = null;
    var order = {};
    var toast = el('[data-toast]'), toastTimer;

    function showToast(t) {
      toast.textContent = t;
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add('is-in');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-in'); setTimeout(function () { toast.hidden = true; }, 250); }, 2200);
    }
    function money(c) { return (c / 100).toFixed(3) + ' ' + T.cur; }
    function pieces(n) { return n === 1 ? T.one : n === 2 ? T.two : n + ' ' + T.many; }
    function styleBy(name) { return S.find(function (s) { return s.name === name; }); }

    function mapSize(style, size) {
      if (!size) return null;
      var exact = style.sizes.find(function (z) { return z.size === size; });
      if (exact) return exact;
      var target = parseFloat(size);
      return style.sizes.slice().sort(function (a, b) { return Math.abs(parseFloat(a.size) - target) - Math.abs(parseFloat(b.size) - target); })[0];
    }

    function scrollToEl(node, extra) {
      var header = document.querySelector('#header-component');
      var off = (header ? header.getBoundingClientRect().height : 0) + (extra || 12);
      window.scrollTo({ top: node.getBoundingClientRect().top + window.scrollY - off, behavior: 'smooth' });
    }

    function nudgeSize() {
      var box = el('[data-sizebox]');
      scrollToEl(box);
      box.classList.remove('is-pulse'); void box.offsetWidth; box.classList.add('is-pulse');
      showToast(T.needSize);
    }

    function setGsize(v) {
      gsize = v;
      root.querySelectorAll('[data-gsize]').forEach(function (x) { var on = x.dataset.gsize === v; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on); });
      el('[data-sizebox]').classList.toggle('is-set', !!v);
    }

    function addLine(styleName, sz, qty) {
      var key = sz.id;
      var cur = order[key] ? order[key].qty : 0;
      if (cur + qty > MAX) showToast(T.max);
      order[key] = { id: sz.id, name: styleName, size: sz.size, cents: sz.cents, qty: Math.min(cur + qty, MAX) };
      render();
    }

    function render() {
      var count = 0, cents = 0, perStyle = {};
      Object.keys(order).forEach(function (k) {
        var l = order[k];
        if (!l.qty) { delete order[k]; return; }
        count += l.qty; cents += l.qty * l.cents;
        perStyle[l.name] = (perStyle[l.name] || 0) + l.qty;
      });
      root.querySelectorAll('[data-style]').forEach(function (card) {
        var n = perStyle[card.dataset.style] || 0;
        var b = card.querySelector('[data-badge]');
        b.hidden = !n; b.textContent = '×' + n;
        card.classList.toggle('is-on', n > 0);
      });
      el('[data-sum-count]').textContent = count ? pieces(count) : (gsize ? T.needItem : T.emptySize);
      el('[data-sum-total]').textContent = count ? money(cents) : '';
      el('[data-bar]').classList.toggle('has-items', count > 0);

      var lines = el('[data-lines]');
      lines.textContent = '';
      Object.keys(order).forEach(function (k) {
        var l = order[k];
        var li = document.createElement('li');
        li.innerHTML = '<span class="posh-svc__lname"></span><span class="posh-svc__lqty"><button type="button" data-lm>−</button><b></b><button type="button" data-lp>+</button></span>';
        li.querySelector('.posh-svc__lname').textContent = l.name + ' · ' + l.size;
        li.querySelector('b').textContent = l.qty;
        li.querySelector('[data-lm]').addEventListener('click', function (e) { e.stopPropagation(); l.qty -= 1; render(); });
        li.querySelector('[data-lp]').addEventListener('click', function (e) { e.stopPropagation(); if (l.qty < MAX) { l.qty += 1; render(); } else showToast(T.max); });
        lines.appendChild(li);
      });
      if (!count) { el('[data-order]').hidden = true; el('[data-sum]').setAttribute('aria-expanded', 'false'); }
    }

    /* المقاس الافتراضي */
    root.querySelectorAll('[data-gsize]').forEach(function (b) {
      b.addEventListener('click', function () { setGsize(b.dataset.gsize); render(); });
    });
    el('[data-help]').addEventListener('click', function () { var h = el('[data-hint]'); h.hidden = !h.hidden; });

    /* أضف سريع */
    root.querySelectorAll('[data-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var style = styleBy(btn.closest('[data-style]').dataset.style);
        if (!gsize) { nudgeSize(); return; }
        var sz = mapSize(style, gsize);
        addLine(style.name, sz, 1);
        btn.classList.remove('is-tap'); void btn.offsetWidth; btn.classList.add('is-tap');
        try { if (navigator.vibrate) navigator.vibrate(10); } catch (e) {}
        showToast('✓ ' + T.added + ' ' + style.name + ' ' + sz.size);
      });
    });

    /* الصفحة المنبثقة */
    var sheet = el('[data-sheet]'), sStyle = null, sSize = null, sQty = 1;
    function sheetRender() {
      el('[data-q]').textContent = sQty;
      el('[data-sheet-add]').textContent = T.sheetAdd + ' · ' + money(sSize.cents * sQty);
      el('[data-sheet-sizes]').querySelectorAll('button').forEach(function (b) { var on = b.dataset.s === sSize.size; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
      var note = el('[data-map-note]');
      var mapped = gsize && !sStyle.sizes.some(function (z) { return z.size === gsize; });
      note.hidden = !mapped;
      if (mapped) note.textContent = T.mapNote.replace('{sizes}', sStyle.sizes.map(function (z) { return z.size; }).join(' · '));
    }
    function openSheet(name) {
      sStyle = styleBy(name);
      sSize = mapSize(sStyle, gsize) || sStyle.sizes[Math.min(1, sStyle.sizes.length - 1)];
      sQty = 1;
      el('[data-sheet-img]').src = sStyle.img;
      el('[data-sheet-img]').alt = sStyle.name;
      el('[data-sheet-name]').textContent = sStyle.name;
      el('[data-sheet-price]').textContent = money(sStyle.sizes[0].cents);
      var sub = el('[data-sheet-sub]'); sub.textContent = sStyle.sub; sub.hidden = !sStyle.sub;
      var box = el('[data-sheet-sizes]'); box.textContent = '';
      sStyle.sizes.forEach(function (z) {
        var b = document.createElement('button');
        b.type = 'button'; b.dataset.s = z.size; b.textContent = z.size; b.setAttribute('role', 'radio');
        b.addEventListener('click', function () { sSize = z; sheetRender(); });
        box.appendChild(b);
      });
      sheetRender();
      sheet.hidden = false;
      document.documentElement.classList.add('posh-svc-lock');
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    }
    function closeSheet() {
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('posh-svc-lock');
      setTimeout(function () { sheet.hidden = true; }, 250);
    }
    root.querySelectorAll('[data-open-sheet]').forEach(function (b) { b.addEventListener('click', function () { openSheet(b.closest('[data-style]').dataset.style); }); });
    root.querySelectorAll('[data-close-sheet]').forEach(function (b) { b.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hidden) closeSheet(); });
    el('[data-q-minus]').addEventListener('click', function () { if (sQty > 1) { sQty--; sheetRender(); } });
    el('[data-q-plus]').addEventListener('click', function () { if (sQty < MAX) { sQty++; sheetRender(); } else showToast(T.max); });
    el('[data-sheet-add]').addEventListener('click', function () {
      addLine(sStyle.name, sSize, sQty);
      closeSheet();
      showToast('✓ ' + T.added + ' ' + sStyle.name + ' ' + sSize.size + (sQty > 1 ? ' ×' + sQty : ''));
    });

    /* ملخص الطلب */
    el('[data-sum]').addEventListener('click', function () {
      if (!Object.keys(order).length) { if (!gsize) nudgeSize(); else showToast(T.needItem); return; }
      var o = el('[data-order]');
      o.hidden = !o.hidden;
      el('[data-sum]').setAttribute('aria-expanded', String(!o.hidden));
    });
    el('[data-clear]').addEventListener('click', function () { order = {}; render(); });

    /* تحويل الدولة للكويت مع حفظ الاختيارات */
    var switchBox = el('[data-switch]');
    var switchForm = el('[data-switch-form]');
    if (switchForm) {
      switchForm.addEventListener('submit', function () {
        try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ g: gsize, o: order, go: true })); } catch (e) {}
      });
    }

    /* اطلب الآن */
    var cta = el('[data-cta]');
    async function checkout() {
      var items = Object.keys(order).map(function (k) { return { id: order[k].id, quantity: order[k].qty }; });
      if (!items.length) {
        if (!gsize) { nudgeSize(); return; }
        scrollToEl(el('[data-cards]'), 20);
        showToast(T.needItem);
        return;
      }
      cta.disabled = true;
      cta.textContent = T.adding;
      try {
        var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
        if (!res.ok) throw new Error('unavailable');
        try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
        window.location.href = '/cart';
      } catch (e) {
        cta.disabled = false;
        cta.textContent = T.cta;
        var country = (window.Shopify && window.Shopify.country) || '';
        if (switchBox && country !== T.country) {
          switchBox.hidden = false;
          el('[data-order]').hidden = true;
        } else {
          showToast(T.error);
        }
      }
    }
    cta.addEventListener('click', checkout);
    var closeSwitch = el('[data-switch-close]');
    if (closeSwitch) closeSwitch.addEventListener('click', function () { switchBox.hidden = true; });

    /* رجّع الاختيارات بعد تحويل الدولة */
    try {
      var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (saved) {
        sessionStorage.removeItem(STORE_KEY);
        if (saved.g) setGsize(saved.g);
        order = saved.o || {};
        render();
        showToast(T.restored);
        if (saved.go && (window.Shopify && window.Shopify.country) === T.country) {
          setTimeout(checkout, 700);
          return;
        }
      }
    } catch (e) {}

    render();
  }

  function boot() { document.querySelectorAll('[data-svc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();